var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({class:['btn', `btn-${_vm.variant}`],attrs:{"type":"button"}},'button',_vm.$attrs,false),[(_vm.icon)?_c('em',{class:_vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }